import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseDashboard } from '../../models/dashboard/BaseDashboard';
import { FormSearch } from '../../models/dashboard/FormStatus';
import { InvoiceApprovalfilterView, InvoiceApprovalView } from '../../models/form/InvoiceApprovalView';
import { UtilityService } from '../utility.service';
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class InvoiceApprovalFormService {
	private readonly urlPath = 'invoice-approval';
	constructor(private httpClient: HttpClient, private utilityService: UtilityService) {}

	createForm(clientId: string, form: InvoiceApprovalView): Observable<InvoiceApprovalView> {
		return this.httpClient
			.post<InvoiceApprovalView>(`${environment.apiUrl}forms/clients/${clientId}/invoice-approval`, form)
			.pipe();
	}

	updateForm(clientId: string, formId: string, request: any): Observable<any> {
		return this.httpClient
			.put<any>(`${environment.apiUrl}forms/clients/${clientId}/invoice-approval/${formId}`, request)
			.pipe();
	}

	uploadFile(clientId: string, formId, file: File, type): Observable<HttpEvent<any>> {
		const formData: FormData = new FormData();
		formData.append('file', file);
		const req = new HttpRequest(
			'POST',
			`${environment.apiUrl}forms/clients/${clientId}/invoice-approval/${formId}/docs?type=${type}`,
			formData,
			{
				reportProgress: true,
				responseType: 'json',
			}
		);
		return this.httpClient.request(req);
	}

	getFormsFor(clientId: string, userId: string, search: FormSearch): Observable<BaseDashboard<any>> {
		let url = `${
			environment.apiUrl
		}forms/clients/${clientId}/invoice-approval/users/${userId}?${this.utilityService.objectToQueryString(search)}`;
		return this.httpClient.get<BaseDashboard<any>>(url).pipe();
	}

	getForm(id: string, clientId: string): Observable<InvoiceApprovalView> {
		return this.httpClient
			.get<InvoiceApprovalView>(`${environment.apiUrl}forms/clients/${clientId}/invoice-approval/${id}`)
			.pipe();
	}
	deleteDocument(clientId: string, formId: any, docId: any): Observable<any> {
		return this.httpClient.delete<any>(
			`${environment.apiUrl}forms/clients/${clientId}/invoice-approval/${formId}/docs/${docId}`
		);
	}
	rejectForm(
		clientId: string,
		formId: string,
		rejectionReason: { reason: string; workflowId: number }
	): Observable<InvoiceApprovalView> {
		return this.httpClient
			.post<InvoiceApprovalView>(
				`${environment.apiUrl}forms/clients/${clientId}/invoice-approval/${formId}/decline`,
				rejectionReason
			)
			.pipe();
	}

	approveForm(clientId: string, formId: string, userId: string): Observable<InvoiceApprovalView> {
		return this.httpClient
			.post<InvoiceApprovalView>(`${environment.apiUrl}forms/clients/${clientId}/invoice-approval/${formId}/approve`, {
				userId,
			})
			.pipe();
	}
	sendBack(clientId: string, formId: string): Observable<InvoiceApprovalView> {
		return this.httpClient
			.post<InvoiceApprovalView>(`${environment.apiUrl}forms/clients/${clientId}/${this.urlPath}/${formId}/review`, {})
			.pipe();
	}

	searchInvoiceApprovals(clientId: string, filters: InvoiceApprovalfilterView): Observable<any> {
		return this.httpClient
			.post<any>(`${environment.apiUrl}forms/clients/${clientId}/invoice-approval/searchInvoiceApprovals`, filters)
			.pipe();
	}

	exportInvoiceApprovals(clientId: string, filters: InvoiceApprovalfilterView): Observable<any> {
		return this.httpClient
			.post(`${environment.apiUrl}forms/clients/${clientId}/invoice-approval/exportInvoiceApprovals`, filters, {
				responseType: 'blob',
			})
			.pipe();
	}

	submitForApproval(clientId: string, id: any, userId: string): Observable<any> {
		return this.httpClient
			.post<any>(`${environment.apiUrl}forms/clients/${clientId}/invoice-approval/${id}/approval`, {
				userId,
			})
			.pipe();
	}
}
